import { MODULE_1_INPUT, MISC_DATA, SET_SELECTED_DATA, GET_FINANCIAL_STATEMENT, DELETE_FINANCIAL_STATMENT, DISPLAY_INFO } from '../actions/transformation_input_one'
import { MOCKASSESSMENTENTRIES } from '../actions/assesment'
// import Vue from 'vue'
import { RepositoryFactory } from '../repositories/RepositoryFactory'
import { UPDATELOGGEDINUSER } from '../actions/user'
// console.log(RepositoryFactory);
const Repository = RepositoryFactory.get('transformation_input_one')

const state = {
  miscData: {},
  /* selectedData: {
     selectedPeriodObject: {},
    selectedDenominationObject: {},
    currentYear: 0,
    previousYear: 0
  } */
  selectedData: localStorage.getItem('inputOneSelectedData') ? JSON.parse(localStorage.getItem('inputOneSelectedData')) : {},
  displayInfo: {},
  setOutput: {}
}

const mutations = {
  [MISC_DATA]: (state, data) => {
    state.miscData = data
    // console.log('mine', state.miscData.currencies)
    localStorage.setItem('miscData', JSON.stringify(data))
  },
  [SET_SELECTED_DATA]: (state, data) => {
    /* state.selectedData.selectedPeriodObject = data.periodObject
    state.selectedData.selectedDenominationObject = data.denominationObject
    state.selectedData.currentYear = data.currentYear
    state.selectedData.previousYear = data.previousYear */
    state.selectedData = data
  },
  [DISPLAY_INFO]: (state, data) => {
    state.displayInfo = data
  },
  [MOCKASSESSMENTENTRIES]: (state, data) => {
    localStorage.setItem('outputData', JSON.stringify(data))
    state.setOutput = data
  }
}

const actions = {
  /**
   * Save module one input one
   */
  [MODULE_1_INPUT]: ({ commit }, loginData) => {
    commit('FORM_SUBMIT')
    commit('ISLOADING', true)
    Repository.login(loginData).then((result) => {
      let token = result.data.token
      // let user = result.data.user
      /* TODO */
      // ~save JWT auth token
      console.log(JSON.parse(atob(token.split('.')[1])))
      // commit(USER_LOGIN, {'token': token, 'loginModalRef': loginData.loginModalRef, 'user': user})
      commit('RESET_SUBMIT')
      commit('NOTIFICATION', { message: 'User logged in' })
    })
      .catch(error => {
        commit('RESET_SUBMIT')
        commit('NOTIFICATION', error.response.data)
      })
    commit('ISLOADING', false)
  },
  [MISC_DATA]: async ({ commit }) => {
    commit('ISLOADING', true)
    try {
      let result = await Repository.getMiscData()
      let response = result.data
      commit('MISC_DATA', response)
      commit('ISLOADING', false)
      return response
    } catch (error) {
      console.log('error', error.response.data)
      commit('NOTIFICATION', error.response.data)
    }
    commit('ISLOADING', false)
  },
  [SET_SELECTED_DATA]: ({ commit }, data) => {
    commit(SET_SELECTED_DATA, data)
  },
  [DISPLAY_INFO]: ({ commit }, data) => {
    commit(DISPLAY_INFO, data)
  },
  [GET_FINANCIAL_STATEMENT]: async ({ commit }, param) => {
    commit('ISLOADING', true)
    try {
      // eslint-disable-next-line no-use-before-define
      let outcomes = await Repository.getFinancialStatement(param)
      // commit(UPDATELOGGEDINUSER, {'data': outcomes.user})
      // let data = outcomes.financialStatements.data[0]
      let data = outcomes.data[0]
      let selectedData = {
        periodObject: data.periods,
        denominationObject: data.denominations,
        currentYear: data.reporting_year,
        previousYear: (Number(data.reporting_year) - 1)
      }
      localStorage.setItem('inputOneSelectedData', JSON.stringify(selectedData))
      localStorage.setItem('codesObject', JSON.stringify(data.codeValues))
      commit('SET_CODES_OBJECT', data.codeValues)
      commit('SET_SELECTED_DATA', selectedData)
      commit('ISLOADING', false)
      return data
    } catch (error) {
      console.log('error fsl', JSON.stringify(error))
      // commit('NOTIFICATION', error.response.data)
    }
    commit('ISLOADING', false)
  },
  [MOCKASSESSMENTENTRIES]: async ({commit}, data) => {
    commit('ISLOADING', true)
    const output = await Repository.getMockAssessmentEntries()
    localStorage.setItem('outputData', JSON.stringify(output.data))
    commit('MOCKASSESSMENTENTRIES', output.data)
    commit('ISLOADING', false)
    return output.data
  },
  [DELETE_FINANCIAL_STATMENT]: async ({commit}, data) => {
    commit('ISLOADING', true)
    const output = await Repository.deleteFinancialStatment(data)
    commit('ISLOADING', false)
    return output['data']
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/modules/transformation_input_one.js